import type { CSSProperties } from 'react'

export type IconName = 'search' | 'close' | 'cart' | 'arrow' | 'chevron' | 'box' | 'printer' | 'scan' | 'drawer' | 'paper' | 'terminal' | 'check' | 'user' | 'menu' | 'minus' | 'plus' | 'trash' | 'warning' | 'software' | 'chat' | 'telegram'
const paths: Record<IconName, string> = {
  search: 'm21 21-4.5-4.5 M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15',
  chat: 'M4 5h16v11H9l-5 4V5z M8 9h8 M8 12h5',
  close: 'm6 6 12 12 M18 6 6 18',
  telegram: 'M21 3 3 10.5l7.5 3L21 3z M21 3l-6 18-4.5-7.5',
  cart: 'M3 3h2l2.4 12h11.7l2-8H6 M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2 M18 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
  arrow: 'M4 12h16 m-6-6 6 6-6 6',
  chevron: 'm9 5 7 7-7 7',
  box: 'm12 3 9 5-9 5-9-5 9-5 M3 8v9l9 5 9-5V8 M12 13v9 M7.5 5.5l9 5',
  printer: 'M7 8V3h10v5 M7 17H3V8h18v9h-4 M7 13h10v8H7z M17 11h1',
  scan: 'M3 8V3h5 M16 3h5v5 M21 16v5h-5 M8 21H3v-5 M7 7v10 M10 7v10 M14 7v10 M17 7v10',
  drawer: 'M3 6h18v14H3z M3 11h18 M9 15h6 M8 3h8',
  paper: 'M7 3h10v18l-3-2-2 2-2-2-3 2V3 M10 7h4 M10 11h4 M10 15h2',
  terminal: 'M3 3h18v13H3z M8 21h8 M12 16v5 M6 7h6 M6 10h3',
  check: 'm5 12 4 4L19 6',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M4 21v-2a8 5 0 0 1 16 0v2',
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  minus: 'M5 12h14',
  plus: 'M5 12h14 M12 5v14',
  trash: 'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',
  warning: 'm12 3 10 18H2L12 3 M12 9v5 M12 17v1',
  software: 'M3 4h18v16H3z M3 9h18 M7 6.5h.01 M10 6.5h.01 m-1 6-2 2 2 2 m6-4 2 2-2 2',
}
export function Icon({ name, size = 20, style }: { name: IconName; size?: number; style?: CSSProperties }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={style}><path d={paths[name]} /></svg>
}
